import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import MaskedInput from "react-text-mask";
import Select from "react-select";
import { baseUrl } from "../index";
import { OtherLink } from "./OtherLink";
import { convertIntoLakh } from "./UtilityComponent/UtilityFunction";
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from "./CustomDate.jsx";

export const HomeForm = ({
    isEditForm,
    onSubmit,
    enquiryNo,
    btnupdate,
    prevData,
    onClose,
    mobileNo,
    Dob,
    specialization,
    suminsured,
    userData,
}) => {

    const [specializationList, setSpecializationList] = useState([]);
    const [sumInsuredList, setSumInsuredList] = useState([]);

    const [hideSumInsured, setHideSumInsured] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [btnValue, setBtnValue] = useState(btnupdate || "View Quotes");
    const [errors, setErrors] = useState({});
    const [dob, setDob] = useState();


    const [userId] = useState(localStorage.getItem("UserID"));


    const [formData, setFormData] = useState({
        MobileNo: "",
        SumInsured: "",
        Occupation: "Doctor",
        /*DOB:"",*/
        Specialization: "",
        SpecializationName: "",
    })


    const today = new Date();
    const maxDate = new Date(
        today.getFullYear() - 18,
        today.getMonth(),
        today.getDate()
    );

    const minDate = new Date(
        today.getFullYear() - 100,
        today.getMonth(),
        today.getDate()
    );

    //console.log(isEditForm, "isEditForm")
    console.log(prevData, "prevData")
    //console.log(specialization, "specialization")
    //console.log(sumInsured, "sumInsured")
    console.log(formData, "formData")

    useEffect(() => {
        setDob(maxDate)
    }, [])


    const initializeForm = async () => {
        const Req = {
            InsurerID: 126,
            MasterType: "covers",
            MasterCode: "doctor",
        };
        const model = {
            URL: "BindMaster_PI",
            PostString: JSON.stringify(Req)
        }
        const Res = await axios.post(`${baseUrl}/central/centralcall/CallReqWithHeader`, model)
        console.log(Res, "Res")
        setSpecializationList(Res.data.Response);
    };

    useEffect(() => {
        initializeForm();
    }, []);

    useEffect(() => {
        if (isEditForm) {
            setIsDisabled(true)
        }
    }, [])
    const specializationOptions = specializationList.map(({ Code, Name }) => ({
        value: Code,
        label: Name,
    }));

    // Custom styles for react-select
    const selectStyles = {
        control: (provided) => ({
            ...provided,
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        }),
        option: (provided) => ({
            ...provided,
            whiteSpace: "normal",
            wordWrap: "break-word",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };

    const getAge = (dateString) => {
        const birthDate = new Date(dateString);
        const ageDiff = Date.now() - birthDate.getTime();
        const ageDate = new Date(ageDiff);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    };



    const validateForm = () => {
        const newErrors = {};
        const age = getAge(dob);

        // Mobile validation
        const invalidMobiles = ["9999999999", "8888888888", "7777777777", "6666666666"];
        if ((!formData.MobileNo || formData.MobileNo.length !== 10 || invalidMobiles.includes(formData.MobileNo)) && !isEditForm) {
            newErrors.mobile = "Please enter valid mobile number";
        }

        // Date of birth validation
        if (!dob && !isEditForm) {
            newErrors.dob = "Select a date";
        } else if (age < 18) {
            newErrors.dob = "Age should be above 18 years";
        }

        // Specialization validation
        if (!formData.Specialization) {
            newErrors.specialization = "Select a specialization";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "mobile" || name === "MobileNo") {
            setFormData((prev) => ({
                ...prev,
                MobileNo: value,
            }));
            validateMobileNumber(value);
        } else if (name === "SumInsured") {
            setIsDisabled(false)
            setFormData((prev) => ({
                ...prev,
                SumInsured: value,
            }));
        } else if (name === "industry" || name === "Occupation") {
            setFormData((prev) => ({
                ...prev,
                Occupation: value,
            }));
        }
    };

    // REPLACE your handleSpecializationChange with this:
    const handleSpecializationChange = async (selectedOption) => {
        if (!selectedOption || !selectedOption.value) {
            setErrors((prev) => ({ ...prev, specialization: "Select a specialization" }));
            return;
        }

        const selectedCode = selectedOption.value;

        setFormData((prev) => ({
            ...prev,
            Specialization: selectedOption.value,
            SpecializationName: selectedOption.label,
            SumInsured: !isEditForm ? "10000000" : formData.SumInsured, // Default sum insured
        }));

        try {
            const sumModel = {
                InsurerID: 126,
                MasterType: "SUMINSURED",
                MasterCode: selectedCode,
            };
            const model = {
                URL: "BindMaster_PI",
                PostString: JSON.stringify(sumModel),
            };

            const res = await axios.post(`${baseUrl}/central/centralcall/CallReqWithHeader`, model);

            console.log("Sum Insured API response:", res.data); // 🔍 DEBUG THIS

            if (res.data?.Response) {
                setSumInsuredList(res.data.Response);
            } else {
                setSumInsuredList([]);
            }

            setErrors((prev) => ({ ...prev, specialization: "" }));
        } catch (err) {
            console.error("Failed to fetch Sum Insured list", err);
        }
        setIsDisabled(false)
    };



    const validateMobileNumber = (value) => {
        let error = {};
        if (!value) {
            error["mobile"] = "Please enter mobile number.";
        } else if (value.length < 10) {
            error["mobile"] = "Please enter a 10-digit mobile number.";
        } else if (/^(\d)\1{5}/.test(value.substring(0, 6))) {
            error["mobile"] = "First 6 digits cannot be all the same.";
        } else {
            error["mobile"] = "";
        }
        setErrors((prev) => ({ ...prev, ...error }));
    };

    useEffect(() => {
        if (!formData.Specialization) {
            setHideSumInsured(true);
        } else {

            setHideSumInsured(false);
        }
    }, [formData.Specialization])


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setBtnValue("View Quotes");
            return;
        }
        try {
            const formReq = {
                MobileNo: formData.MobileNo,
                DOB: formatDate(dob),
                Email: null,
                TermYear: 1,
                Occupation: "Doctor",
                SumInsured: formData.SumInsured,
                TypeofSpecialization: formData.Specialization,
                TypeofSpecializationLabel: formData.SpecializationName,
            };

            if (isEditForm) {
                onSubmit?.({ ...formReq, EnquiryNo: enquiryNo });
            } else {
                const response = await axios.post(
                    `${baseUrl}/central/centralcall/CallReqWithHeader`,
                    {
                        URL: "GetEnquiry_PI",
                        PostString: JSON.stringify({
                            MobileNo: formData.MobileNo,
                            EnquiryType: "PI",
                            LeadSource: "online",
                            AllianceID: 52,
                            BusinessID: localStorage.getItem("BusinessID"),
                            UserID: !userId ? 0 : userId,
                        }),
                    }
                );

                if (response.data.StatusCode === 200) {
                    onSubmit?.({ ...formReq, EnquiryNo: response.data.Response });
                }
            }
        } catch (error) {
            console.error("Submission error:", error);
            setBtnValue("View Quotes");
        }
    };
    useEffect(() => {
        if (isEditForm) {
            setFormData(prev => ({
                ...prev,
                Occupation: "Doctor",
                MobileNo: prevData?.MobileNo,
                SumInsured: prevData?.SumInsured,
                Specialization: prevData?.TypeofSpecialization,
                SpecializationName: prevData?.TypeofSpecializationLabel,
            }))

            const initializeSumInsured = async () => {
                try {
                    const sumModel = {
                        InsurerID: 126,
                        MasterType: "SUMINSURED",
                        MasterCode: prevData?.TypeofSpecialization,
                    };
                    const model = {
                        URL: "BindMaster_PI",
                        PostString: JSON.stringify(sumModel),
                    };
                    const res = await axios.post(`${baseUrl}/central/centralcall/CallReqWithHeader`, model);
                    setSumInsuredList(res.data.Response || []);
                    console.log(res, "setSumInsuredList")
                } catch (err) {
                    console.error("Failed to fetch Sum Insured list", err);
                }
            }
            initializeSumInsured()
        }
    }, [])

    console.log(specializationList, "specializationList")
    return (

        <>
            {/* Mobile Input */}

            {!isEditForm &&
                <>
                    <div className="indemnity-wrap indemnity1">
                        <MaskedInput
                            mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                            guide={false}
                            showMask={false}
                            className="indemtexted"
                            id="mobile"
                            name="mobile"
                            value={formData.MobileNo}
                            placeholder=" "
                            onChange={handleChange}
                            autoComplete="off"
                        />
                        <label htmlFor="mobile" className="invest-label">
                            Mobile Number
                        </label>
                        {errors.mobile && <span className="INDerror">{errors.mobile}</span>}
                        <i className="fas fa-mobile-alt" />
                    </div>
                    <div className="indemnity-wrap indemnity1">
                        <label htmlFor="dob" className="Date_Inp">
                            Date Of Birth
                        </label>
                        <CustomDatePicker
                            setDOB={(date) => setDob(date)}
                            minDate={minDate}
                            maxDate={maxDate}
                            RegDate={dob}
                        //selected={dob}
                        />
                        {errors.dob && <span className="INDerror">{errors.dob}</span>}
                        <small className="UserAge">
                            <b>{getAge(dob)} years</b>
                        </small>
                    </div>
                </>
            }
            <div className="indemnity-wrap indemnity1">
                <label htmlFor="ForUp1" className="Date_Inp">Occupation</label>
                <select id="industry" className="indemtexted" name="industry" value={formData.Occupation} onChange={handleChange}>
                    <option value="DOCTOR" selected>Doctor</option>
                </select>
                <span className="INDerror">{errors["Industry"]}</span>
            </div>
            <div className="indemnity-wrap indemnity1">
                <label className="Date_Inp">Specialization</label>
                <Select
                    id="specialization"
                    name="specialization"
                    value={specializationOptions.find(opt => opt.value === formData.Specialization) || null}
                    onChange={handleSpecializationChange}
                    options={specializationOptions}
                    styles={selectStyles}
                    placeholder="Select Specialization"
                />

                {/*<select*/}
                {/*    name="Specialization"*/}
                {/*    className="indemtexted SumInsuredDropDownField"*/}
                {/*    value={formData.Specialization}*/}
                {/*    onChange={handleSpecializationChange}*/}
                {/*>*/}
                {/*    <option value="">Select Specialization</option>*/}
                {/*    {specializationList.map((row) => (*/}
                {/*        <option key={row.Code} value={row.Code}>*/}
                {/*            {convertIntoLakh(row.Name)}*/}
                {/*        </option>*/}
                {/*    ))}*/}
                {/*</select>*/}

                {errors.specialization && (
                    <span className="INDerror">{errors.specialization}</span>
                )}
            </div>
            {!hideSumInsured && (
                <div className="indemnity-wrap indemnity1">
                    <label
                        htmlFor="SumInsured"
                        className="Date_Inp"
                    >
                        Sum Insured
                    </label>
                    <select
                        id="SumInsured"
                        name="SumInsured"
                        className="indemtexted SumInsuredDropDownField"
                        value={formData.SumInsured}
                        onChange={handleChange}
                    >
                        <option value="">Select Sum Insured</option>
                        {sumInsuredList
                            .slice()
                            .sort((a, b) => parseInt(a.Name) - parseInt(b.Name))
                            .map((row) => (
                                <option key={row.Name} value={row.Name}>
                                    {convertIntoLakh(row.Name)}
                                </option>
                            ))}
                    </select>
                    {errors.sumInsured && <span className="INDerror">{errors.sumInsured}</span>}
                </div>
            )}
            <div className="mt-2">
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="IndemBTN"
                    disabled={(formData.MobileNo === "" || formData.MobileNo.length !== 10 || formData.Specialization === "") || isDisabled}
                >
                    {btnValue}
                </button>
            </div>

            {/* Terms and Conditions */}
            <div className="indTERM">
                <small>
                    By clicking I agree to all{" "}
                    <span className="green-text">
                        <a
                            href="https://www.smcinsurance.com/terms-of-use"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            T&C
                        </a>
                    </span>
                </small>
            </div>
            {!isEditForm &&
                <OtherLink />
            }
        </>
    )

};

// Modified formatDate to handle both string and Date inputs
const formatDate = (date) => {
    const d = date instanceof Date ? date : new Date(date);
    return [
        d.getDate().toString().padStart(2, "0"),
        (d.getMonth() + 1).toString().padStart(2, "0"),
        d.getFullYear(),
    ].join("-");
};